import {useRouter} from "next/router";

export function useCurrentRoute(): string {
  const router = useRouter();

  if (router?.asPath === "/") return "index";

  return router?.asPath?.slice(1);
}
